<template>
  <div class="TopicId">

    <TopicHeader
      ref="TopicHeader"
      :topic-search-word="topicSearchWord"
      @search="searchTopic"
    />
    <TopicClassify
      :topic-classify="topicClassify"
      :topic-classify-id="topicClassifyId"
      :topic-classify-sort-id="topicClassifySortId"
      :switch-vip-type="TOPIC.SORT_LIST"
      @toggleClassify="toggleClassify"
      @toggleType="toggleType"
      :params="params"
    />
    <div class="inner_center">
      <PicList :pic-list="topicList"
               @picItemTopicClick="picItemTopicClick"
               @topicMouseover="topicMouseover"
      />
    </div>

    <PicPackageEmptyList
      @navTo="navTo"
      v-show="topicList.length == 0 && loading == true"
    />

    <CtPagination
      class="ct-pagination"
      v-if="pagination.totalPage > 1"
      :total-page="pagination.totalPage"
      :paper-count="5"
      :current-page="pagination.page"
      @pageClick="pageClick"
    />

<!--    <NoLoginBar/>-->

    <!-- <websiteRatingModel /> -->

    <no-ssr>
      <ActSlot/>
    </no-ssr>
  </div>
</template>

<script>
import TopicHeader from '@/components/topic/topic-header';
import PicList from '@/components/pic/pic-list/pic-list';

// import TopicNav from '@/components/topic/topic-nav';
import TopicList from '@/components/topic/topic-list';
import TopicClassify from '@/components/topic/topic-classify'
import CtPagination from '@/components/common/ct-pagination/ct-pagination';
import PicPackageEmptyList from '@/components/pic-package/empty-list.vue'

import {fnBrowser, fnLogin, fnRouter, fnTopic} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {getTopicClassify, getTopicClassify2, getTopicList} from "@/api/topic";
import {listGetNextDate} from "@/components/tupian/common/list";
import NoLoginBar from '@/components/common/login/no-login-bar'
import {parseListUrl} from "@/components/list/module";
import {mapGetters} from "vuex";
import fnCollection from "@/fn/topic/fnCollection";
import {TOPIC} from "@/constant/tupian/TOPIC";
import mixin from "@/pages/topic/mixin";
import ActSlot from '@/components/_Privately/Act/ActSlot'
import {setPicViewType} from "@/components/_Privately/Pic/Common/module";

export default {
  name: "TopicId",
  layout: "header-nav",
  components: {
    TopicHeader,
    // TopicNav,
    TopicList,
    PicList,
    TopicClassify,
    CtPagination,
    PicPackageEmptyList,
    NoLoginBar,
    ActSlot
  },
  mixins: [mixin],

  head() {
    return {
      title: this.tkd.title,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.tkd.keywords
        },
        {
          hid: 'description',
          name: 'description',
          content: this.tkd.description
        },
        {
          property: 'article:published_time',
          content: this.published_time
        }
      ]
    }
  },
  computed: {
    ...mapGetters('layout', ['screenWidth', 'bannerHeight']),
    isShowListBar() {
      return this.$store.state.base.isShowListBar
    },
    isLogin() {
      return this.$store.state.user.isLogin
    }
  },
  watch: {
    isLogin(n, o) {
      if (n || n == true || n == false) {
        // this.initFooter();
      }
    },
  },
  data() {
    return {
      PAGE_PATH,
      navData: {
        title: '灵感探索',
        list: []
      },
      pagination: {
        totalPage: 10,
        page: 1
      },
      topicSearchWord: '',
      topicList: [],
      id: this.$route.params.id || this.$route.query.id,
      pinyin: '',
      topicClassify: [], // 分类
      topicClassifyId: 0, // 分类
      topicClassifySortId: 0, // 分类
      // topicNav: [], // 分类
      tkd: {},
      published_time: '',
      loading: false,
      TOPIC,
      params: {}

    }
  },

  async asyncData({app}) {
    let UA = app.context.req.headers['user-agent']
    const {route} = app.context;
    let id = route.params.id;
    let {pinyin, page, category, sort} = fnTopic.disposeTopicId(id);
    console.log({
      pinyin, page, category, sort
    })

    let [
      // topicNav,
      topicList,
      topicClassify,
    ] = await Promise.all([
      // app.$api.getTopicNav(),
      app.$api.getTopicList({keyword: pinyin, page, category, sort}),
      app.$api.getTopicClassify(),

    ])

    let {list, page: currentPage, pages, tkd, search_word} = topicList.data

    console.log('--list--')
    // console.log(topicList.data)

    list = fnCollection.disposeRecommendList(list)

    return {
      // topicNav: fnTopic.disposeTopicClassify(topicNav.data),
      topicList: list,
      topicClassify: [{name: '全部', id: 0}].concat(topicClassify.data),
      pagination: {totalPage: pages, page: currentPage},
      tkd: tkd,
      published_time: listGetNextDate(),
      isSpider: fnBrowser.isSpider(UA),
      topicSearchWord: search_word,
      loading: true,
      params: fnTopic.disposeTopicId(id),
    }

  },
  async mounted() {
    this.parseId();
    this.topicPositionStat();
    this.initQuery();

    /* this.getTopicList();
     this.getTopicClassify();*/

  },
  methods: {
    initFooter() {
      if (!fnLogin.checkLogin()) {
        document.getElementById('FooterWrap').style.display = 'none';
      } else {
        document.getElementById('FooterWrap').style.display = 'block';
      }
    },

    //用&拼接对象成字符串
    getParams(params) {
      let paramStr = '';
      Object.keys(params)
        .forEach((item) => {
          if (paramStr === '') {
            paramStr = `${item}=${params[item]}`;
          } else {
            paramStr = `${paramStr}&${item}=${params[item]}`;
          }
        });
      console.log(paramStr);
      return paramStr;
    },


    initQuery() {
      this.queryParams = this.getParams(this.$route.query)
    },

    parseId() {
      let {pinyin, page} = fnTopic.disposeTopicId(this.id);
      this.pinyin = pinyin
      this.pagination.page = page
    },

    getTopicClassify() {
      getTopicClassify2().then(res => {
        // let {data} = res.data;
        this.topicClassify = [{name: '全部', id: 0}].concat(res.data.data)
        console.log(this.topicClassify)
      })
    },

    getTopicList() {
      let id = this.$route.params.id;
      let {pinyin, page, category, sort} = fnTopic.disposeTopicId(id);

      getTopicList({
        /*keyword: this.pinyin,
        page: this.pagination.page*/
        keyword: pinyin, page, category, sort
      }).then(res => {
        let {data} = res.data;
        console.log(data)
        // this.topicList = fnTopic.disposeTopicClassify(data.list)
        this.topicList = fnCollection.disposeRecommendList(data.list)
        this.pagination = {totalPage: data.pages, page: data.page}
        this.tkd = data.tkd;
        this.topicSearchWord = data.topicSearchWord;
        this.loading = true;
      })
    },

    searchTopic(searchWord) {
      searchWord = searchWord == '' ? 0 : searchWord;
      this.pinyin = searchWord;
      this.pagination.page = 1;
      // this.getTopicList();
      // this.pageClick(this.pagination.page)
      /* 重置 */
      // this.params.category = 0
      // this.params.sort = 'sort';
      let path = PAGE_PATH.TOPIC.DEFAULT + `/${searchWord}-1-0-sort.html`
      path = this.queryParams ? path + '?' + this.queryParams : path;
      fnRouter.navigationTo(path, '_self');
    },


    pageClick(page) {
      this.pagination.page = page;
      let {DEFAULT} = PAGE_PATH.TOPIC
      let pinyin = this.$refs.TopicHeader.searchWord;
      let path = `${DEFAULT}`;

      let {category, sort} = fnTopic.disposeTopicId(this.id);
      let routerPath = addParams(path, pinyin, page);
      routerPath = this.queryParams ? routerPath + '?' + this.queryParams : routerPath;
      fnRouter.navigationTo(routerPath, '_self');


      function addParams(path, pinyin, page) {
        let tempPath
        if (pinyin !== '') {
          if (page > 1) {
            tempPath = `${path}/${pinyin}-${page}-${category}-${sort}.html`
          } else {
            tempPath = `${path}/${pinyin}-0-${category}-${sort}.html`
          }
        } else {
          if (page > 1) {
            tempPath = `${path}/0-${page}-${category}-${sort}.html`
          } else {
            tempPath = `${path}`
          }
        }
        return tempPath;
      }
    },

    navTo() {
      fnRouter.navigationTo(PAGE_PATH.FEEDBACK)
    },
    toggleClassify(vo) {
      // this.topicClassifyId = vo.id;
      let {pinyin, page, category, sort} = fnTopic.disposeTopicId(this.id);
      let link = PAGE_PATH.BASE_URL + PAGE_PATH.TOPIC.DEFAULT + `/${pinyin}-1-${vo.id}-${sort}.html`

      link = this.queryParams ? link + '?' + this.queryParams : link;
      fnRouter.navigationTo(link, '_self')
    },

    toggleType(vo) {

      this.topicClassifySortId = vo.id;
      let {pinyin, page, category, sort} = fnTopic.disposeTopicId(this.id);
      let link = PAGE_PATH.BASE_URL + PAGE_PATH.TOPIC.DEFAULT + `/${pinyin}-1-${category}-${vo.sort}.html`
      link = this.queryParams ? link + '?' + this.queryParams : link;
      fnRouter.navigationTo(link, '_self')
    },


    /* 专题统计 */
    topicPositionStat() {
      if (this.topicList.length) {
        let ids = this.topicList.map(item => item.id);
        fnTopic.positionStat(
          ids.toString(),
          TOPIC.POSITION_STAT.EVENT.EXPOSE,
          TOPIC.POSITION_STAT.POSITION.TOPIC,
        )
      }
    },
    picItemTopicClick(topicId) {
      fnTopic.positionStat(
        topicId,
        TOPIC.POSITION_STAT.EVENT.CLICK,
        TOPIC.POSITION_STAT.POSITION.TOPIC,
      )
    },

    topicMouseover(topicId) {
      fnTopic.positionStatMouseOver(
        topicId, TOPIC.POSITION_STAT.POSITION.TOPIC,
      )
    },


  }

}
</script>

<style lang="scss" scoped>
.ct-pagination {
  margin: 16px 0 64px;
}
</style>
